import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import UploadPopup from "./UploadResume";
import "./jdtable.css";
import CandidatesTable from "./sideTable";

const JobsTable = ({ onJobSelect }) => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showUploadPopup, setShowUploadPopup] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [jobsPerPage] = useState(4); // Adjust rows per page
  const [candidates, setCandidates] = useState([]);
  const navigate = useNavigate();
  const [jobId, setjobId] = useState(null);

  useEffect(() => {
    fetchJDs();
    fetchCandidates();
  }, []);

  const fetchJDs = async () => {
    try {
      const response = await fetch("/api/get_jd", {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch JDs");
      }

      const data = await response.json();
      setJobs(data);
      setjobId(data[0].job_id);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching JDs:", error);
      setLoading(false);
    }
  };

  const getActionIconUrl = (idx) => {
    const urls = [
      "5e65a24a80c9538f7891b250878cb0a10188ef8860a73d06fc57a763ad1e4d1c",
      "a54464106c5f3adf98bfeda08b3f6bebbd8b4e7d970ba3effa762046772b0ee3",
      "3f056c95851d2ed3363ac48b650a813c35419401c97e66f51c8b765c61463203",
      "887ee278d711169193225de39a088542e8d9bc6fddf15d06ec29ef8e0eaaa573",
      "8ec4737935d2c13bbac895a54e9765961fb06a1bd7a045dc41a219b69ec3e0b1",
      "a6cf2e28566ed64f3ea20f2808602de3fa53951b105b2e2af65425735cc2b6d6",
    ];
    return urls[idx];
  };

  const fetchCandidates = async () => {
    try {
      const response = await fetch(`/api/candidatelist?jobId=${jobId}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });

      if (!response.ok) throw new Error("Failed to fetch Candidates");

      const data = await response.json();
      setCandidates(data);
    } catch (error) {
      console.error("Error fetching Candidates:", error);
    }
  };

  const handleApplicantClick = (jobId) => {
    navigate(`/ranking?jobID=${encodeURIComponent(jobId)}`, {
      state: { jobID: jobId },
    });
    onJobSelect(jobId);
  };

  const handleUploadClick = (event, jobId) => {
    event.stopPropagation();
    setSelectedJobId(jobId);
    setShowUploadPopup(true);
  };

  const handleDeleteClick = (event, jobId) => {
    event.stopPropagation();
    setSelectedJobId(jobId);
    setShowDeletePopup(true);
  };

  const handleClosePopup = () => {
    setShowUploadPopup(false);
    setShowDeletePopup(false);
    setSelectedJobId(null);
  };

  // Pagination Logic
  const indexOfLastJob = currentPage * jobsPerPage;
  const indexOfFirstJob = indexOfLastJob - jobsPerPage;
  const currentJobs = jobs.slice(indexOfFirstJob, indexOfLastJob);
  const totalPages = Math.ceil(jobs.length / jobsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  if (loading) {
    return (
      <div className="loader-container">
        <div className="spinner"></div>
      </div>
    );
  }


  const convertToIST = (gmtDate) => {
    // Create a Date object from the GMT date string
    const date = new Date(gmtDate);

    // Format the date to a beautified string (e.g., March 13, 2025, 12:46 PM)
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true, // To show AM/PM
    };
    return date.toLocaleString('en-IN', options);
  };

  return (
    <>
      <div className="jd-table-container">
        <div className="jd-table-header">
          <span>Created on</span>
          <span className="jd-table-jt">Job Title</span>
          <span className="jd-table-status">Status</span>
          <span className="jd-table-eng">Engagement</span>
          <span className="jd-table-actions">Actions</span>
        </div>

        {currentJobs.map((job, index) => (
          <div
            key={index}
            className="jd-table-row"
            onClick={() => handleApplicantClick(job.job_id)}
          >
            <span className="jd-date">{convertToIST(job.created_at)}</span>
            <div className="jd-title-wrapper">
              <span className="jd-title">{job.job_title}</span>
              <span className="jd-location">
                {job.experience_range} - {job.location}
              </span>
            </div>
            <span className="jd-status">{job.status || "Active"}</span>
            <div className="jd-engagement">
              <span className="jd-views">{job.applicants || 0} Views</span>
              <span className="jd-applied">{job.applicants || 0} Applied</span>
              <span className="jd-recommended">
                {job.applicants || 0} Recommended Candidates
              </span>
            </div>
            <div className="jd-actions">
              {[1, 2, 3, 4, 5, 6].map((_, idx) => (
                <img
                  key={idx}
                  className="jd-action-icon"
                  src={`https://cdn.builder.io/api/v1/image/assets/TEMP/${getActionIconUrl(idx)}`}
                  alt="Action"
                  onClick={(event) => {
                    if (idx === 2) {
                      handleUploadClick(event, job.job_id);
                    } else if (idx === 5) {
                      handleDeleteClick(event, job.job_id);
                    }
                  }}
                  title={
                    idx === 0
                      ? "Edit"
                      : idx === 1
                        ? "Duplicate"
                        : idx === 2
                          ? "Upload Resume"
                          : idx === 3
                            ? "Save Job"
                            : idx === 4
                              ? "Download"
                              : "Delete Job"
                  }
                />
              ))}
            </div>
          </div>
        ))}

        {/* Updated Pagination Controls */}
        <div className="pagination-ch">
          {/* Left Arrow */}
          <button
            className="page-btn arrow-btn"
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
          >
            ←
          </button>

          {/* Active Page Number */}
          <span className="page-number">{currentPage}</span>

          {/* Right Arrow */}
          <button
            className="page-btn arrow-btn"
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            →
          </button>
        </div>

        {showUploadPopup && (
          <UploadPopup jobId={selectedJobId} onClose={handleClosePopup} />
        )}

        {showDeletePopup && (
          <div className="popup-overlay-res">
            <div className="popup-container">
              <h2>Delete Job</h2>
              <p>All data regarding tests and results of candidates will be lost. Are you sure about Deleting the Job?</p>
              <div className="popup-buttons">
                <button className="popup-button cancel" onClick={handleClosePopup}>
                  Cancel
                </button>
                <button className="popup-button upload">
                  Delete Job
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

    </>
  );
};

export default JobsTable;
